var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsSnsTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6497 4H15.9421V18.9855C15.9421 20.771 14.5161 22.2377 12.7415 22.2377C10.9669 22.2377 9.54088 20.771 9.54088 18.9855C9.54088 17.2319 10.9352 15.7971 12.6464 15.7333V11.971C8.87541 12.0348 5.83325 15.1275 5.83325 18.9855C5.83325 22.8754 8.93879 26 12.7732 26C16.6075 26 19.7131 22.8435 19.7131 18.9855V11.3014C21.1074 12.3217 22.8186 12.9275 24.6249 12.9594V9.1971C21.8363 9.10145 19.6497 6.80579 19.6497 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSnsTiktok);
export default __webpack_public_path__ + "static/media/icons-sns-tiktok.2a181b803e60e64fce6915e09e409a2f.svg";
export { ForwardRef as ReactComponent };